import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-orange-50 p-6">
          <div className="max-w-lg bg-white border border-red-200 rounded-lg p-6 shadow-md">
            <h1 className="text-xl font-bold text-red-700 mb-2">Something went wrong</h1>
            <p className="text-gray-700 mb-4">
              The app hit an unexpected error. Try refreshing the page.
            </p>
            <pre className="text-xs bg-gray-100 p-3 rounded overflow-auto text-red-800">
              {this.state.error.message}
            </pre>
            <button
              type="button"
              className="mt-4 btn-primary"
              onClick={() => window.location.reload()}
            >
              Reload
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
